import React, { useState, useEffect } from 'react';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
import Masonry from 'react-masonry-css';
import WorkFilter from "../../components/Work/WorkFilter";
import WorkItem from "../../components/Work/WorkItem";
import workData from '../../data/work/workDetails.json';
import {slugify} from "../../utils";

const Portfolio = () => {
    const [categories, setCategories] = useState([]);
    const [activeFilter, setActiveFilter] = useState('all');
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        // Get all unique categories from workData
        const allCats = workData.flatMap(item => item.categories.map(cat => slugify(cat)));
        const uniqueCategories = ['all', ...new Set(allCats)];
        setCategories(uniqueCategories);
        setFilteredData(workData);
    }, []);

    useEffect(() => {
        // Filter data based on activeFilter
        if (activeFilter === 'all') {
            setFilteredData(workData);
        } else {
            const newFilteredData = workData.filter(item =>
                item.categories.map(cat => slugify(cat)).includes(activeFilter)
            );
            setFilteredData(newFilteredData);
        }
    }, [activeFilter]);


    const breakpointColumnsObj = {
        default: 3,
        1200: 3,
        992: 2,
        768: 2,
        576: 1
    };

    return (
        <div className="section section-padding ag-masonary-wrapper">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <SectionTitle
                            showWithSpan={true}
                            subTitle="Portfolios"
                            title="Selected works."
                        />
                    </div>
                    <div className="col-lg-7" data-aos="fade-up" data-aos-delay="300">
                        <WorkFilter
                            categories={categories}
                            activeFilter={activeFilter}
                            setActiveFilter={setActiveFilter}
                        />
                    </div>
                </div>

                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid mesonry-list"
                    columnClassName="my-masonry-grid_column"
                >
                    {filteredData.map(portfolio => (
                        <WorkItem key={portfolio.id} portfolio={portfolio}/>
                    ))}
                </Masonry>
            </div>
        </div>
    );
};

export default Portfolio;
